import React from 'react';
import { Factory, Palmtree } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';
import { cardImage } from '../utils/imageOptimizer';

const iconMap = {
  Factory,
  Palmtree
};

export const DestinationsSection = () => {
  const { settings } = useSettings();
  const { t, getBilingualValue } = useLanguage();
  
  const destinations = [
    {
      nameKey: 'destinations.batam',
      icon: 'Factory',
      descKey: 'destinations.batamDesc',
      gradient: 'from-blue-100 to-green-100',
      image: settings.destinations?.batam?.image
    },
    {
      nameKey: 'destinations.bintan',
      icon: 'Palmtree',
      descKey: 'destinations.bintanDesc',
      gradient: 'from-green-100 to-teal-100',
      image: settings.destinations?.bintan?.image
    }
  ];
  
  return (
    <section id="destinations" className="container mx-auto px-6 py-20">
      <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
        {getBilingualValue(settings.destinations?.title, 'destinations.title')}
      </h2>
      <div className="grid md:grid-cols-2 gap-12">
        {destinations.map((dest, idx) => {
          const IconComponent = iconMap[dest.icon];
          return (
            <div key={dest.nameKey} className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-200 hover:shadow-2xl transition-shadow">
              <div className={`h-64 bg-gradient-to-r ${dest.gradient} flex items-center justify-center`}>
                {dest.image ? (
                  <img src={cardImage(dest.image)} alt={t(dest.nameKey)} className="w-full h-full object-cover" />
                ) : (
                  IconComponent && <IconComponent size={120} className="text-gray-300" strokeWidth={1.5} />
                )}
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold mb-4">{t(dest.nameKey)}</h3>
                <p className="text-gray-700 leading-relaxed">{t(dest.descKey)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
